import { useState } from "react";
import { ApiError } from "../../common/api/ApiClient";
import { useApiClient } from "../../common/hooks/useApiClient";
import {
  TagFormat,
  CirclePersonResponse,
} from "../../common/models/schema/CirclePersonResopnse";
import { useCircleTasks } from "../../common/contexts/CircleTaskProvider";
import { CircleTaskStatus } from "../../common/models/schema/CircleTaskSchema";
const apiPath = "/circle/persons";

export const useUploadCircle = () => {
  const [personId, setPersonId] = useState("");
  const [person, setPerson] = useState<CirclePersonResponse | null>(null);
  const [tags, setTags] = useState<TagFormat[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const apiClient = useApiClient();
  const { setTask } = useCircleTasks();

  const handleSubmit = async () => {
    if (!personId.trim()) return;

    setLoading(true);
    setError(null);

    try {
      await apiClient.post<CirclePersonResponse>(apiPath, {
        person_id: Number(personId),
      });

      setTask({
        id: personId,
        task_status: CircleTaskStatus.RUNNING,
        task_result: null,
        created_at: new Date(),
        updated_at: new Date(),
        error: null,
      });
      setPersonId("");
    } catch (err) {
      const apiError = err as ApiError;
      setError(apiError.data?.detail || apiError.message);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setError(null);
    setPerson(null);
    setTags([]);

    // Only allow numbers
    if (/^\d*$/.test(value)) {
      setPersonId(value);
    }
  };

  const resetForm = () => {
    setPersonId("");
    setPerson(null);
    setTags([]);
    setError(null);
  };

  return {
    // State
    personId,
    person,
    tags,
    loading,
    error,

    // Actions
    handleSubmit,
    handleInputChange,
    resetForm,
  };
};
